export default __webpack_public_path__ + "static/media/icon-status-confirmed.13c28064.svg";